import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mood-light-testing',
  templateUrl: './mood-light-testing.component.html',
  styleUrls: ['./mood-light-testing.component.scss']
})
export class MoodLightTestingComponent implements OnInit {

  colors = ["", "", "", "", "", "", "", ""];
  backgroundElement: any;
  backgroundCircleElement: any;

    // Blink-secreen properties
    strobeRunning = false;
    warningAccepted = false;
    mainTimer;
  
    timerInterval = 1;
    currentColorIndex = 0;
    colorsTransition = 1;
    totalRounds = 8;
  
    sliderValue = 28; // Frequency controller
    DeltaFrequencyValue = 25; // Frequency controller
    ThetaFrequencyValue = 29; // Frequency controller
    AlphaFrequencyValue = 33; // Frequency controller
    BetaFrequencyValue = 39; // Frequency controller
    
    private oscillateObj: any = {
      constant: undefined,
      variant: undefined,
    };

    constantFrequencyHeartz=440;
    DeltaFrequencyHeartz = 0;
    ThetaFrequencyHeartz = 0;
    AlphaFrequencyHeartz = 0;
    BetaFrequencyHeartz = 0;

  constructor() { }

  ngOnInit(): void {
    this.colors = ["ED2939", "383838", "ED2939", "383838", "ED2939", "383838", ""];
    this.startBlink(0)
  }

  ngAfterViewInit(): void {
    // this.backgroundCircleElement = document.getElementById('strobe_div');
    // this.backgroundElement = document.getElementById('strobe_div-overlay');
  }

  DeltaclickOk(){
    this.startBlink(this.DeltaFrequencyValue)
    this.startOscillation(440, 'constant');
    this.startOscillation(442, 'variant');
  }

  ThetaclickOk(){
    this.startBlink(this.ThetaFrequencyValue)
    this.startOscillation(440, 'constant');
    this.startOscillation(446, 'variant');
  }
  AlphaclickOk(){
    this.startBlink(this.AlphaFrequencyValue)
    this.startOscillation(440, 'constant');
    this.startOscillation(450, 'variant');
  }
  BetaclickOk(){
    this.startBlink(this.BetaFrequencyValue)
    this.startOscillation(440, 'constant');
    this.startOscillation(456, 'variant');
  }

  startBlink(val) {
    this.backgroundElement = document.getElementById('strobe_div-overlay');
    this.backgroundElement.style.display = 'block';

    this.backgroundCircleElement = document.getElementById('strobe_div');

    this.setSliderValue(val)
  }

  startStrobe(interval) {
    this.timerInterval = (interval == null) ? this.timerInterval : interval;

    this.strobeRunning = true;
    this.mainTimerFunction();
  }

  mainTimerFunction = () => {
    // re-set timer
    if (this.strobeRunning == true) {
      clearTimeout(this.mainTimer);
      this.mainTimer = setTimeout(this.mainTimerFunction, this.timerInterval);
    }

    // get next used color
    this.currentColorIndex = this.getNextColor();

    if ((this.colorsTransition == 0) || (this.sliderValue >= 93)) {
      this.backgroundCircleElement.style.background = "#" + this.colors[this.currentColorIndex]
    } else {
      this.backgroundCircleElement.style.background = "#" + this.colors[this.currentColorIndex]
    }


    this.currentColorIndex++;
  }

  getNextColor() {
    var next_color = this.currentColorIndex;

    while (this.colors[next_color] == "") {
      next_color++;
      if (next_color > 6) {
        next_color = 0;
      }
    }
    if (next_color > 6) {
      next_color = 0;
    }

    return next_color;
  }

  setSliderValue(val, update_slider: boolean = true, set_unsaved: boolean = true) {

    var update_slider = (update_slider == null) ? true : update_slider;
    var set_unsaved = (set_unsaved == null) ? true : set_unsaved;

    // check boundaries
    if (val < 1) {
      val = 1;
    }
    if (val > 123) {
      val = 123;
    }

    // update
    this.sliderValue = +(val);
    this.strobeRunning = true;

    if (this.sliderValue <= 5) {
      this.timerInterval = +((6 - this.sliderValue) * (1000 * 60));
    } else if (this.sliderValue <= 15) {
      // every 50, 40, 30, 25, 20, 15, 10 secs
      var display_value = 60 - ((this.sliderValue - 5) * 5);
      this.timerInterval = (display_value * 1000);
    } else if (this.sliderValue <= 24) {
      this.timerInterval = +((25 - this.sliderValue) * 1000);
    } else if (this.sliderValue >= 53) {
      // 30, 35, 40, 45, 50, 55, 60 per sec
      var display_value = 30 + ((this.sliderValue - 53) * 5);
      this.timerInterval = +(1000 / display_value);
    } else {
      this.timerInterval = +(1000 / (this.sliderValue - 23));
    }

    // restart timer
    if (this.strobeRunning == true) {
      this.startStrobe(null);
    }
  }

  stopStrobe() {
    this.strobeRunning = false;
    clearTimeout(this.mainTimer);
    // this.backgroundElement.style.display = 'none';
    this.stopOscillation()
  }


  private startOscillation(freq, frerType: 'variant' | 'constant', val = 0.1) {
    if (typeof this.oscillateObj[frerType]?.oscillator != 'undefined') this.oscillateObj[frerType]?.oscillator.disconnect();
    this.oscillatOn(freq, frerType);
    this.oscillateObj[frerType].gainValue = val;
  }

  private oscillatOn(freq, frerType: 'variant' | 'constant') {
    // const contextClass = (window.AudioContext ||
    //   window?.webkitAudioContext ||
    //   window.mozAudioContext ||
    //   window.oAudioContext ||
    //   window.msAudioContext);
    const contextClass = (window.AudioContext);
    const context: any = new contextClass();
    let gainValue = 0.9;
    let gainNode = context.createGain ? context.createGain() : context.createGainNode();
    let oscillator;

    let oscs = { sine: 0, square: 1, sawtooth: 2, triangle: 3 };


    oscillator = context.createOscillator();

    oscillator.type = 0;
    oscillator.frequency.value = freq;

    oscillator.connect(gainNode);
    gainNode.connect(context.destination);
    gainNode.gain.value = gainValue;

    if (oscillator.type === parseInt(oscillator.type)) {
      oscillator.type = 0;
    } else {
      oscillator.type = "sine";
    }
    oscillator.start ? oscillator.start(0) : oscillator.noteOn(0)
    // oscillator.start(0);
    this.oscillateObj[frerType] = oscillator
  }

  private stopOscillation() {
    this.oscillateObj['constant']?.stop();
    this.oscillateObj['variant']?.stop();

    this.oscillateObj['constant']?.disconnect();
    this.oscillateObj['variant']?.disconnect();
  }
}
